"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AnalyticsController = function () {
  function AnalyticsController(AnalyticsService, $q) {
    "ngInject";

    (0, _classCallCheck3.default)(this, AnalyticsController);
    this.analyticsService = AnalyticsService;
    this.$q = $q;
  }

  (0, _createClass3.default)(AnalyticsController, [{
    key: "$onInit",
    value: function $onInit() {
      this.isLoading = false;
    }
  }]);
  return AnalyticsController;
}();

exports.default = AnalyticsController;


/** WEBPACK FOOTER **
 ** ./client/app/containers/analytics-marketing/analytics-marketing.controller.js
 **/